/* eslint-disable no-restricted-syntax */
import { Config } from 'configs';
import * as yup from 'yup';

export const TranslationFieldOptions = {
  REQUIRE_ALL: {
    allOptional: false,
    atLeastOneTranslation: false,
  },
  REQUIRE_AT_LEAST_ONE: {
    allOptional: true,
    atLeastOneTranslation: true,
  },
  OPTIONAL: {
    allOptional: true,
    atLeastOneTranslation: false,
  },
};

export const getValidationShapeForTranslatableText = (translationItem, options) => {
  const schemaItems = {};

  const translatableInputOptions = options || { ...TranslationFieldOptions.OPTIONAL };

  const isTranslationRequired = !translatableInputOptions.allOptional;

  Config.AVAILABLE_LANGUAGES.forEach((language) => {
    let stringSchema;

    if (isTranslationRequired) {
      stringSchema = yup
        .string()
        .nullable()
        .default(translationItem?.[language])
        .required(`Please enter translation for language ${language}`);
    } else if (translatableInputOptions.atLeastOneTranslation) {
      const anotherLanguages = Config.AVAILABLE_LANGUAGES.filter((lang) => lang !== language);

      stringSchema = yup.lazy(() => yup.string().nullable().default(translationItem?.[language]).when(anotherLanguages, {
        is: (...val) => {
          if (!val) {
            return true;
          }

          let atLeastOneAvailable = false;

          for (let i = 0; i < val.length; i += 1) {
            if (val[i]) {
              atLeastOneAvailable = true;
              break;
            }
          }

          return !atLeastOneAvailable;
        },
        then: yup.string().required('Must enter at least one language'),
      }));
    } else {
      stringSchema = yup.string().nullable().default(translationItem?.[language]);
    }

    schemaItems[language] = stringSchema;
  });

  return schemaItems;
};

export const getValidationPairsForTranslatableText = () => {
  const otherLanguagePairs = [];

  Config.AVAILABLE_LANGUAGES.forEach((language) => {
    const anotherLanguages = Config.AVAILABLE_LANGUAGES.filter((lang) => lang !== language);

    if (anotherLanguages && anotherLanguages.length > 0) {
      otherLanguagePairs.push(anotherLanguages);
    }
  });

  return otherLanguagePairs;
};

export const fillTranslatableTexts = (translationItem) => {
  if (!translationItem) {
    return translationItem;
  }

  const translationItemTemp = { ...translationItem };

  let defaultValue;

  for (let i = 0; i < Config.ORDERED_AVAILABLE_LANGUAGES.length; i += 1) {
    if (translationItem[Config.ORDERED_AVAILABLE_LANGUAGES[i]]) {
      defaultValue = translationItem[Config.ORDERED_AVAILABLE_LANGUAGES[i]];
      break;
    }
  }

  /*
  Config.AVAILABLE_LANGUAGES.forEach((lang) => {
    if (!translationItem[lang]) {
      translationItemTemp[lang] = defaultValue;
    }
  }); */

  // only fill english
  if (!translationItem.en) {
    translationItemTemp.en = defaultValue;
  }

  return translationItemTemp;
};

export const getAvailableTranslatableText = (translationItem) => {
  if (!translationItem) {
    return '';
  }

  if (translationItem[Config.DEFAULTS.LANGUAGE]) {
    return translationItem[Config.DEFAULTS.LANGUAGE];
  }

  for (let i = 0; i < Config.ORDERED_AVAILABLE_LANGUAGES.length; i += 1) {
    if (translationItem[Config.ORDERED_AVAILABLE_LANGUAGES[i]]) {
      return translationItem[Config.ORDERED_AVAILABLE_LANGUAGES[i]];
    }
  }

  return '';
};
